"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _Banner = require("../Banner/Banner");
var _classnames = _interopRequireDefault(require("classnames"));
var _CardModule = _interopRequireDefault(require("./Card.module.css"));
var _excluded = ["type", "background", "backgroundProps", "body", "transparent", "className", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Card = function Card(_ref) {
  var _classNames;
  var type = _ref.type,
    background = _ref.background,
    backgroundProps = _ref.backgroundProps,
    body = _ref.body,
    transparent = _ref.transparent,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card, _extends({
    className: (0, _classnames.default)(_CardModule.default.card, _CardModule.default[type], className)
  }, props), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card.Img, {
    as: 'div',
    variant: 'top',
    className: _CardModule.default.imgContainer
  }, type === 'img' && /*#__PURE__*/_react.default.createElement(_Banner.Banner, _extends({
    imgUrl: background
  }, backgroundProps)), type === 'video' && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Ratio, backgroundProps, /*#__PURE__*/_react.default.createElement("iframe", {
    src: background,
    frameBorder: 0,
    allowFullScreen: true
  }))), body ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card.Body, {
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, _CardModule.default.body, true), _defineProperty(_classNames, _CardModule.default.transparent, transparent), _classNames)),
    dangerouslySetInnerHTML: {
      __html: body
    }
  }) : children ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Card.Body, null, children) : null);
};
exports.Card = Card;
Card.propTypes = {
  type: _propTypes.default.oneOf(['img', 'video']),
  onClick: _propTypes.default.func,
  background: _propTypes.default.string,
  backgroundProps: _propTypes.default.object,
  body: _propTypes.default.string,
  transparent: _propTypes.default.bool
};
Card.defaultProps = {
  type: 'img',
  background: 'http://sportcache.lider-bet.com/news/img/1f2d86c347aa1667ca591874badf786af0bc8c7c.jpg',
  backgroundProps: {
    aspectRatio: 0.67,
    style: {
      backgroundPosition: 'center top'
    }
  },
  /*body: '<p>დაიბრუნე 20% ნებისმიერ სლოტში!</p>',*/
  transparent: false
};